function ratingPoint(el) {
  for (let i = 0; i < 5; i++) {
    let spanEl = document.createElement("span");
    if (i < Math.round(el.dataset.point)) {
      spanEl.classList.add("star");
    } else {
      spanEl.classList.add("star-border");
    }
    spanEl.addEventListener("click", (e) => {
      ratingClick(spanEl, i);
    });
    el.append(spanEl);
  }
}

function ratingClick(el, i) {
  el.parentNode.dataset.point = i + 1;
  let spanEls = el.parentNode.querySelectorAll("span");
  spanEls.forEach((spanEl, index) => {
    if (index <= i) {
      spanEl.classList.remove("star-border");
      spanEl.classList.add("star");
    } else {
      spanEl.classList.remove("star");
      spanEl.classList.add("star-border");
    }
  });
}

function ratingInit() {
  let ratingEls = document.querySelectorAll(".jsRating");
  if (ratingEls) {
    ratingEls.forEach((ratingEl) => {
      ratingPoint(ratingEl);
    });
  }
}

window.addEventListener("load", (e) => {
  ratingInit();
});